import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";

// TODO: Replace with your Firebase project configuration
// Get this from Firebase Console > Project Settings > General > Your apps > SDK setup and configuration
const firebaseConfig = {
    apiKey: "AIzaSyA2hLgoV-nYiGNQqx50IUU6IVNGy6ZlPTQ",
    authDomain: "danicahalley-ui.firebaseapp.com",
    projectId: "danicahalley-ui",
    storageBucket: "danicahalley-ui.firebasestorage.app",
    messagingSenderId: "323888911756",
    appId: "1:323888911756:web:757bc582eb3151812972a9",
    measurementId: "G-Y2L30WJTYJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export default app;
